import { useContext } from 'react';

import type { RibbonConfigContextValue } from './types';

import { RibbonConfigContext } from './index';

/**
 * Hook to access ribbon configuration context.
 * Throws an error if used outside of RibbonConfigProvider.
 */
export function useRibbonConfig(): RibbonConfigContextValue {
	const context = useContext(RibbonConfigContext);

	if (!context) {
		throw new Error('useRibbonConfig must be used within a RibbonConfigProvider');
	}

	return context;
}
